module.exports = __webpack_public_path__ + "img/Makeup.ed25f097.jpeg";